import React from "react";
import { Filter, TextInput } from "react-admin";

export const CouponFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by coupon name" source="coupon_name" alwaysOn />
  </Filter>
);
